"use client";

import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import WhatsAppFormModal from "./WhatsAppFormModal";

const IFRAME_SRC = "/yaris-cross-360/index.htm";

const Viewer360Desktop: React.FC = () => {
	const [formOpen, setFormOpen] = useState(false);

	return (
		<>
			<div className="fixed inset-0 w-full border-0 overflow-hidden">
				<iframe
					src={IFRAME_SRC}
					className="absolute inset-0 w-full h-full border-0"
					title="Tour Virtual 360º Yaris Cross"
				/>
			</div>
			<div className="fixed z-[9999] left-1/2 right-auto bottom-6 -translate-x-1/2">
				<button
					type="button"
					onClick={() => setFormOpen(true)}
					className="flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20BD5A] text-white font-normal text-base uppercase tracking-wide py-3 px-6 rounded-xl shadow-lg transition-colors"
				>
					<span>FALE COM NOSSOS CONSULTORES</span>
					<FaWhatsapp className="w-6 h-6 flex-shrink-0" aria-hidden />
				</button>
			</div>
			<WhatsAppFormModal isOpen={formOpen} onClose={() => setFormOpen(false)} />
		</>
	);
};

export default React.memo(Viewer360Desktop);
